import { initComponent } from "../../../utilities/common";
import formStyles from "../form-styles/styles.css";
export default class LocationField {
  constructor(element) {
    this.element = element;
    this.form = element.closest("form");
    this.churchProduct = element.closest('[data-type="church-product"]');
    const searchBtn = element.querySelector("[map-search-btn]");
    const input = element.querySelector("[data-location-field]");
    const compass = this.form?.querySelector("[data-location-field-compass]");

    compass?.addEventListener("click", () => {
      const guid = compass.dataset.formGuid;
      element.querySelector(`[data-location-field]`).value = "GEOLOCATE";
      document.querySelector(`[data-guid-target="${guid}"]`).submit();
    });

    input?.addEventListener("input", () => {
      input.classList.remove(formStyles.invalid);
    });

    searchBtn?.addEventListener("click", () => {
      const allowEmptySearch =
        input?.dataset?.allowEmptySearch === "true" || false;

      if (!allowEmptySearch && !input?.value?.trim()) {
        input?.classList.add(formStyles.invalid);
        return;
      }

      if (this.form) {
        this.form.submit();
        return;
      }

      this.churchProduct?.dispatchEvent(
        new CustomEvent("location-search-click", {
          detail: {
            value: input?.value || ""
          }
        })
      );
    });

    element.checkIsValid = () => this.checkIsValid();
  }

  checkIsValid = () => {
    const input = this.element.querySelector("input");
    if (input.required) {
      return input.value !== "" && input.value !== null;
    }
    return true;
  };
}

export const init = () => {
  initComponent("location-field", (element) => new LocationField(element));
};
init();
